import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortName',
  standalone: true,
})
export class ShortNamePipe implements PipeTransform {
  transform(value: string | undefined): any {
    if (!value) {
      return '';
    }
    const clearValue = value.replace(/[^a-zA-Z0-9 ]/g, '');
    if (!clearValue) {
      return '';
    }
    const ar = clearValue.split(' ').filter((x) => x !== '');
    if (ar.length === 1) {
      return ar[0][0].toUpperCase();
    }
    return `${ar[0][0].toUpperCase()}${ar[1][0].toUpperCase()}`;
  }
}
